module.exports = __webpack_public_path__ + "img/Autocolant TCLHE_55mm x 60mm-01.3e2d5fdf.jpg";